// =======================================================
// INCLUDE HEADER & FOOTER
// =======================================================

// Promise.all([
//         fetch("includes/header.html").then(res => res.text()),
//         fetch("includes/footer.html").then(res => res.text())
//     ])
//     .then(([header, footer]) => {
//         document.getElementById("header").innerHTML = header;
//         document.getElementById("footer").innerHTML = footer;

//         handleHeaderSwitch();
//         initNavbarBehavior();
//         setActiveNavLink();
//     })
//     .catch(err => console.error(err));


// =======================================================
// HEADER SWITCH LOGIC (SIMPLE)
// =======================================================

function handleHeaderSwitch() {
    const path = window.location.pathname;
    // const isHome = path === "/" || path.endsWith("index.html"); 
    const isHome = path.endsWith("/intelligible-website/") || path.endsWith("/intelligible-website/index.html");


    const homeHeader = document.querySelector(".home-header");
    const innerHeader = document.querySelector(".inner-header");

    if (!homeHeader || !innerHeader) return;

    if (!isHome) {
        // Inner pages → always inner header
        homeHeader.classList.add("d-none");
        innerHeader.classList.remove("d-none");
        return;
    }

    // Home page logic
    homeHeader.classList.remove("d-none");
    innerHeader.classList.add("d-none");

    window.addEventListener("scroll", () => {
        if (window.scrollY > 50) {
            homeHeader.classList.add("d-none");
            innerHeader.classList.remove("d-none");
        } else {
            homeHeader.classList.remove("d-none");
            innerHeader.classList.add("d-none");
        }
    });
}


// =======================================================
// ADD BODY CLASS FOR CSS CONTROL
// =======================================================

function setBodyClass(isHome) {
    document.body.classList.remove("home-page", "inner-page");
    document.body.classList.add(isHome ? "home-page" : "inner-page");
}


// =======================================================
// NAVBAR SCROLL & MOBILE BEHAVIOR
// =======================================================

function initNavbarBehavior() {
    const homeHeader = document.querySelector(".home-header");
    const innerHeader = document.querySelector(".inner-header");
    const innerCollapse = document.getElementById("navInner");

    if (!homeHeader || !innerHeader || !innerCollapse) return;

    document.querySelectorAll(".navbar-toggler").forEach(toggler => {
        toggler.addEventListener("click", e => {
            const headerType = toggler.dataset.header;

            // Only for mobile
            if (window.innerWidth >= 992) return;

            if (headerType === "home") {
                // STOP Bootstrap default toggle
                e.preventDefault();
                e.stopPropagation();

                // Switch headers
                homeHeader.classList.add("d-none");
                innerHeader.classList.remove("d-none");

                // Open INNER menu programmatically
                const bsCollapse = bootstrap.Collapse.getOrCreateInstance(innerCollapse);
                bsCollapse.show();
            }
        });
    });

    // When inner menu closes → restore home header (home page only)
    innerCollapse.addEventListener("hidden.bs.collapse", () => {
        const isHome =
            window.location.pathname.endsWith("/intelligible-website/") ||
            window.location.pathname.endsWith("/intelligible-website/index.html");

        // FORCE close HOME menu if it exists
        const homeCollapse = document.getElementById("navHome");
        if (homeCollapse) {
            const homeInstance = bootstrap.Collapse.getOrCreateInstance(homeCollapse);
            homeInstance.hide();
        }

        // Switch headers (home page only & at top)
        if (isHome && window.scrollY < 50) {
            innerHeader.classList.add("d-none");
            homeHeader.classList.remove("d-none");
        }
    });
}


// =======================================================
// CLOSE HEADER ON OUTSIDE CLICK (MOBILE ONLY)
// =======================================================

document.addEventListener("click", (e) => {
    if (window.innerWidth >= 992) return; // desktop ignore

    const innerHeader = document.querySelector(".inner-header");
    const homeHeader = document.querySelector(".home-header");
    const innerCollapse = document.getElementById("navInner");
    const homeCollapse = document.getElementById("navHome");

    // If click is inside any header → do nothing
    if (
        (innerHeader && innerHeader.contains(e.target)) ||
        (homeHeader && homeHeader.contains(e.target))
    ) {
        return;
    }

    // Close INNER menu if open
    if (innerCollapse && innerCollapse.classList.contains("show")) {
        bootstrap.Collapse.getOrCreateInstance(innerCollapse).hide();
    }

    // Close HOME menu if open
    if (homeCollapse && homeCollapse.classList.contains("show")) {
        bootstrap.Collapse.getOrCreateInstance(homeCollapse).hide();
    }

    let lastScrollY = window.scrollY;

    window.addEventListener("scroll", () => {
        if (window.innerWidth >= 992) return; // desktop ignore

        // Only react to actual scrolling
        if (Math.abs(window.scrollY - lastScrollY) < 5) return;
        lastScrollY = window.scrollY;

        const innerCollapse = document.getElementById("navInner");
        const homeCollapse = document.getElementById("navHome");

        // Close INNER menu if open
        if (innerCollapse && innerCollapse.classList.contains("show")) {
            bootstrap.Collapse.getOrCreateInstance(innerCollapse).hide();
        }

        // Close HOME menu if open
        if (homeCollapse && homeCollapse.classList.contains("show")) {
            bootstrap.Collapse.getOrCreateInstance(homeCollapse).hide();
        }
    });
});





// =======================================================
// ACTIVE NAV LINK (BOLD / COLOR)
// =======================================================

function setActiveNavLink() {
    const path = window.location.pathname;
    const currentPage = path.split("/").pop() || "index.html";

    document.querySelectorAll(".navbar .nav-link").forEach(link => {
        const href = link.getAttribute("href");
        if (!href || href === "#") return;

        const linkPage = href.split("/").pop() || "index.html";

        if (linkPage === currentPage) {
            link.classList.add("active");
        } else {
            link.classList.remove("active");
        }
    });
}



// =======================================================
// AOS INIT
// =======================================================

document.addEventListener("DOMContentLoaded", () => {
    AOS.init({
        duration: 3000,
        once: true,
        delay: 300
    });
});


// // Fetch enquire form dynamically
// fetch('includes/enquire-form.html')
//     .then(res => res.text())
//     .then(html => {
//         // Inject form into body
//         document.body.insertAdjacentHTML('beforeend', html);

//         // Now initialize the form interactions
//         initEnquireForm();
//     })
//     .catch(err => console.error('Enquire form load error:', err));

window.addEventListener("scroll", function () {
  const navbar = document.querySelector(".navbar");

  if (window.scrollY > 50) {
    navbar.classList.add("scrolled");
  } else {
    navbar.classList.remove("scrolled");
  }
});
// SCROLL EFFECT (ONLY HOME)
const navbar = document.querySelector(".navbar");

if (navbar && navbar.classList.contains("navbar-home")) {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      navbar.classList.add("scrolled");
    } else {
      navbar.classList.remove("scrolled");
    }
  });
}

// CLOSE BUTTON
const closeBtn = document.getElementById("menuClose");
const menu = document.getElementById("mainNav");

if (closeBtn && menu) {
  closeBtn.addEventListener("click", () => {
    const bsCollapse = bootstrap.Collapse.getInstance(menu);
    if (bsCollapse) bsCollapse.hide();
  });
}
// Function to attach event listeners
function initEnquireForm() {
    let scrollY = 0;
    const enquireBtns = document.querySelectorAll('.enquire-btn');
    const panel = document.getElementById('enquirePanel');
    const overlay = document.getElementById('enquireOverlay');
    const productName = document.getElementById('enquireProductName');
    const hiddenProduct = document.getElementById('hiddenProduct');
    const closeBtn = document.querySelector('.enquire-close');

    if (!panel || !overlay) return;

    enquireBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();

            const product = btn.dataset.product;
            if (productName) productName.textContent = product;
            if (hiddenProduct) hiddenProduct.value = product;

            // Save scroll position
            scrollY = window.scrollY;

            // Lock body scroll
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';

            panel.classList.add('active');
            overlay.classList.add('active');
        });
    });

    function closePanel() {
        panel.classList.remove('active');
        overlay.classList.remove('active');

        // Unlock body scroll
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';

        // Restore scroll position
        window.scrollTo(0, scrollY);
    }

    overlay.addEventListener('click', closePanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
}
// ===============================
// SUPPORT FORM FIX
// ===============================
document.addEventListener("DOMContentLoaded", function () {

  const supportButtons = document.querySelectorAll('.support-types button');
  const supportInput = document.getElementById('support_type');

  if (!supportButtons.length || !supportInput) return;

  supportButtons.forEach(button => {
    button.addEventListener('click', () => {

      supportButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      // 🔥 sync with Shopify form
      supportInput.value = button.getAttribute('data-value');
    });
  });

});
document.addEventListener('DOMContentLoaded', async () => {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const badge = document.getElementById('cart-count-badge');
    if (badge && cart.item_count > 0) {
      badge.textContent = cart.item_count;
      badge.style.display = 'block';
    }
  } catch(e) {}
});